<template>
  <va-edit-layout :title="title">
    <va-form :id="uid" :item="item">
      <v-row justify="center">
        <v-col sm="4">
          <base-material-card :icon="resource.icon" :title="title">
            <v-card-text>
              <va-text-input source="uid"></va-text-input>
              <va-text-input source="title"></va-text-input>
              <va-text-input source="isbn"></va-text-input>
              <va-save-button></va-save-button>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: {
    uid: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
    resource: {
      type: Object,
      default: null,
    },
  },
};
</script>
